(function () {
  'use strict';

  angular.module('bitrix24').factory('bitrix24', bitrix24Factory);

  bitrix24Factory.$inject = ['$window'];

  function bitrix24Factory($window) {
    if (typeof $window.BX24 == 'undefined' || !$window.BX24) {
      throw new Error("Can't load bitrix js library");
    }

    try {
      $window.BX24.init(function () {
        $window.BX24.openPath('/crm/deal/details/1/', function (result) {
          console.log(result);
        });
      });
    } catch (e) {
      throw new Error("Can't load because not inside bitrix24");
    }

    var bitrix24 = $window.BX24;

    return bitrix24;
  }
})();
